import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { cache, placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useNotification } from '@btime/react-messager'
import { useNavigate } from '@reach/router'
import { useTranslation } from 'react-i18next'

const MUTATION = gql`
  mutation UpsertPlaceType($input: PlaceTypeInput) {
    upsertPlaceType(input: $input) {
      id
      key
    }
  }
`

const validate = (form, setErrors, t) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: t('requiredField') }),
    ...appendIf(!form.namePlural, { path: ['namePlural'], message: t('requiredField') }),
    ...appendIf(!form.icon, { path: ['icon'], message: t('requiredField') })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSavePlaceType = () => {
  const closeModal = useCloseModal()
  const navigate = useNavigate()
  const notify = useNotification()
  const { t } = useTranslation('placeTypes')
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['PlaceType'], client: placesClient })

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      const input = cleanRequest(form)
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: t('successSave') })
          cache.reset()
          closeModal()
          navigate(`/places/${resp.data.upsertPlaceType.key}`)
          return
        }

        notify.error({ title: t('errorSave') })
      })
    }
  }

  return [handleRequest, state]
}
